import { Component } from '@angular/core';
import { AnalyticsService } from 'src/core/services/analytics.service';
import { AuthStateService } from 'src/core/services/authstate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  title = 'vb-bpl';

  // Damit Analytics immer direkt geladen werden
  constructor(
    private analyticsService: AnalyticsService,
    private authStateService: AuthStateService
  ) {}
}
